import * as React from 'react';
import ErrorIcon from '@material-ui/icons/Error';

import * as styles from './announcement.module.scss';

interface Props {
  message: string;
}

/**
 * @function FailureAnnouncement - Component for failure messages
 */
const FailureAnnouncement = ({ message }: Props) => {
  return (
    <div className={styles.failureAnnouncement}>
      <ErrorIcon />
      <span>{message}</span>
    </div>
  );
};

export default FailureAnnouncement;
